import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

type StructuralIconProps = Omit<React.ComponentProps<typeof FontAwesomeIcon>, 'icon'> & {
	icon: IconDefinition;
};

const StructuralIcon = ({ icon, ...props }: StructuralIconProps) => {
	return <FontAwesomeIcon icon={icon} {...props} />;
};

export { StructuralIcon };
export type { StructuralIconProps };
